"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFORMATION_KEY = exports.RoleTypeTypes = void 0;
var RoleTypeTypes;
(function (RoleTypeTypes) {
    RoleTypeTypes["TITULAR"] = "TIT";
    RoleTypeTypes["ADDITIONAL"] = "AUT";
})(RoleTypeTypes = exports.RoleTypeTypes || (exports.RoleTypeTypes = {}));
exports.INFORMATION_KEY = 'https://naranja.com/info';
